import { useTranslation } from "react-i18next";import React from 'react';
import { Plus, Edit, Copy, Download } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/shared/components/ui/card';
import { Badge } from '@/shared/components/ui/badge';
import { Button } from '@/shared/components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/shared/components/ui/tabs';

export const TemplatesManager = () => {const { t } = useTranslation("ezparcel");
  const approvedTemplates = notificationTemplates.filter((t) => t.status === 'approved');
  const activeTemplates = notificationTemplates.filter((t) => t.status === 'active');

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">{t("messageTemplates", "Message Templates")}</h1>
          <p className="text-muted-foreground mt-2">{t("manageNotificationTemplates", "Manage notification templates with variables and multi-language support")}

          </p>
        </div>
        <Button className="bg-[hsl(var(--accent))] hover:bg-[hsl(var(--accent-hover))]">
          <Plus className="mr-2 h-4 w-4" />{t("createTemplate", "Create Template")}

        </Button>
      </div>

      {/* Stats */}
      <div className="grid gap-4 md:grid-cols-4">
        <Card>
          <CardContent className="p-6">
            <p className="text-sm text-muted-foreground">{t("totalTemplates", "Total Templates")}</p>
            <p className="text-3xl font-bold mt-2">{notificationTemplates.length}</p>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="p-6">
            <p className="text-sm text-muted-foreground">{t("whatsappApproved", "WhatsApp Approved")}</p>
            <p className="text-3xl font-bold mt-2 text-green-600">{approvedTemplates.length}</p>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="p-6">
            <p className="text-sm text-muted-foreground">{t("telegramActive", "Telegram Active")}</p>
            <p className="text-3xl font-bold mt-2 text-blue-600">{activeTemplates.length}</p>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="p-6">
            <p className="text-sm text-muted-foreground">{t("totalUsage", "Total Usage")}</p>
            <p className="text-3xl font-bold mt-2">
              {notificationTemplates.reduce((sum, t) => sum + t.usage, 0).toLocaleString()}
            </p>
          </CardContent>
        </Card>
      </div>

      {/* Templates List */}
      <Tabs defaultValue="all">
        <TabsList>
          <TabsTrigger value="all">{t("allTemplates", "All Templates")}</TabsTrigger>
          <TabsTrigger value="whatsapp">{t("whatsapp", "WhatsApp")}</TabsTrigger>
          <TabsTrigger value="telegram">{t("telegram", "Telegram")}</TabsTrigger>
        </TabsList>

        <TabsContent value="all" className="space-y-4 mt-6">
          {notificationTemplates.map((template) =>
          <Card key={template.id} className="card-elevated">
              <CardContent className="p-6">
                <div className="flex items-start justify-between mb-4">
                  <div className="flex-1">
                    <div className="flex items-center gap-3 mb-2">
                      <h3 className="text-lg font-semibold">{template.name}</h3>
                      <Badge className={
                    template.channel === 'telegram' ?
                    'bg-blue-100 text-blue-700' :
                    'bg-green-100 text-green-700'
                    }>
                        {template.channel.toUpperCase()}
                      </Badge>
                      <Badge className={
                    template.status === 'approved' ?
                    'status-badge status-completed' :
                    'status-badge status-in-progress'
                    }>
                        {template.status.toUpperCase()}
                      </Badge>
                      <Badge variant="outline">
                        {template.tone}
                      </Badge>
                    </div>
                    <p className="text-sm text-muted-foreground">{template.category.replace('_', ' ')}</p>
                  </div>
                  <div className="flex gap-2">
                    <Button variant="outline" size="sm">
                      <Edit className="h-4 w-4" />
                    </Button>
                    <Button variant="outline" size="sm">
                      <Copy className="h-4 w-4" />
                    </Button>
                  </div>
                </div>

                <div className="p-4 bg-muted/50 rounded-lg border border-border mb-4">
                  <p className="text-sm font-mono whitespace-pre-wrap">{template.template}</p>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <p className="text-sm text-muted-foreground mb-2">{t("variables", "Variables")}</p>
                    <div className="flex flex-wrap gap-2">
                      {template.variables.map((variable, idx) =>
                    <Badge key={idx} variant="outline" className="font-mono text-xs">
                          {`{{${variable}}}`}
                        </Badge>
                    )}
                    </div>
                  </div>
                  <div>
                    <p className="text-sm text-muted-foreground mb-2">{t("usageStatistics", "Usage Statistics")}</p>
                    <div className="flex gap-4 text-sm">
                      <span>{t("total", "Total:")}<span className="font-medium">{template.usage.toLocaleString()}</span></span>
                      {template.estimatedCost > 0 &&
                    <span>{t("estCost", "Est. Cost:")}<span className="font-medium">${template.estimatedCost}</span></span>
                    }
                      {template.optIn &&
                    <Badge variant="outline" className="text-xs">{t("optinRequired", "Opt-in Required")}</Badge>
                    }
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          )}
        </TabsContent>
      </Tabs>
    </div>);

};